import { createLinkChain } from 'utils/apollo/initializeApolloClient';
import { useApolloClient } from '@apollo/client';
import { useApp } from 'selectors/appSelector';
import { useDispatch } from 'react-redux';
import { useFeatureFlagForConsumer } from 'featureFlags/useConsumerFeatureFlag';
import { usePrevious } from '@tock/hooks';
import React from 'react';

/**
 * This component is responsible for reinitializing the apollo client when the user's login state changes (as represented
 * by app.jwtToken.)
 */
const ApolloConfigurationStateMonitor: React.FunctionComponent = () => {
  const dispatch = useDispatch();

  const apolloClient = useApolloClient();
  const app = useApp();
  const prevApp = usePrevious(app);

  const batchLinkEnabled = useFeatureFlagForConsumer('CONSUMER_GRAPHQL_REQUEST_BATCHING');

  /**
   * Recreate the GraphQL client link if the JWT token is changed OR
   * the active business changed while inside the Chase iFrame.
   *
   * See link for more info.
   *
   * @link https://squarespace.atlassian.net/browse/TK-20890
   */
  React.useEffect(() => {
    if (prevApp) {
      if (app.jwtToken !== prevApp.jwtToken) {
        apolloClient.setLink(createLinkChain(app, dispatch, { batchLinkEnabled }));
      }
    }
  }, [apolloClient, app, batchLinkEnabled, dispatch, prevApp]);

  return null;
};

export default ApolloConfigurationStateMonitor;
